import React from 'react';
import './technology-compliance.css';
import { FaShieldAlt, FaCogs, FaRegLightbulb, FaLock, FaRegCheckCircle } from 'react-icons/fa';

const TechnologyCompliance = () => {
  return (
    <section className="technology-compliance-section clip-path-section ">
      <div className="container py-4 py-md-5">

        {/* Section Heading */}
        <header className="text-center mb-4 mb-md-5">
          <h2 className="display-3 fw-bold mb-3 text-white">
            <FaCogs className="me-3 micro-wiggle-icon" />
            Advanced Technology & Strong Compliance Framework
          </h2>
          <p className="lead text-white-75 mx-auto" style={{ maxWidth: '800px' }}>
            Enabling our ecosystem with secure digital infrastructure, responsible automation,
            and a commitment to regulatory-aligned practices across all operations.
          </p>
        </header>

        <div className="row g-4">

          {/* Technology Card */}
          <div className="col-lg-6">
            <div className="feature-card holographic-tilt shadow-custom p-4 h-100">
              <div className="card-icon-wrapper mb-3">
                <FaRegLightbulb className="card-icon" />
              </div>
              <h3 className="card-title fw-bold text-primary-dark">
                Technology Innovation: Powering Intelligent Digital Lending
              </h3>
              <p className="card-text text-secondary-dark">
                Our platform leverages advanced automation and data-driven insights to support 
                efficient credit evaluation and smoother digital journeys for our partner brands.
              </p>

              <ul className="list-unstyled mt-4">
                <li><FaRegCheckCircle className="me-2 text-accent-blue" /> Data-Driven Risk Assessment Models (with human oversight)</li>
                <li><FaRegCheckCircle className="me-2 text-accent-blue" /> Scalable Microservices-Based Architecture</li>
                <li><FaRegCheckCircle className="me-2 text-accent-blue" /> API-Driven Infrastructure for Seamless Integrations</li>
                <li><FaRegCheckCircle className="me-2 text-accent-blue" /> Automated Workflow Engine for Faster Operations</li>
              </ul>
            </div>
          </div>

          {/* Compliance Card */}
          <div className="col-lg-6">
            <div className="feature-card holographic-tilt shadow-custom p-4 h-100">
              <div className="card-icon-wrapper mb-3">
                <FaShieldAlt className="card-icon" />
              </div>
              <h3 className="card-title fw-bold text-primary-dark">
                Compliance First: Governance, Security & Responsible Practices
              </h3>
              <p className="card-text text-secondary-dark">
                We follow a governance-driven approach to ensure transparency, customer protection,
                and adherence to applicable regulatory guidelines in digital lending.
              </p>

              <ul className="list-unstyled mt-4">
                <li><FaLock className="me-2 text-accent-blue" /> End-to-End Data Security with Industry-Standard Encryption</li>
                <li><FaLock className="me-2 text-accent-blue" /> Risk & Compliance Controls including KYC, Data Privacy & Responsible Lending Standards</li>
                <li><FaLock className="me-2 text-accent-blue" /> Robust Data Governance Framework for Secure Information Management</li>
                <li><FaLock className="me-2 text-accent-blue" /> Continuous Monitoring & Internal Audits for Operational Integrity</li>
              </ul>
            </div>
          </div>

        </div>

        {/* CTA Strip */}
        <div className="cta-strip mt-5 p-4 text-center rounded-3 holographic-tilt">
          <p className="mb-0 fw-bold text-white">
            <FaRegLightbulb className="me-2 pulse-icon" />
            Built on a foundation of Security, Innovation & Responsible Compliance.
          </p>
        </div>

      </div>
    </section>
  );
};

export default TechnologyCompliance;
